import { WorkflowTypeId } from 'api/types'

// AZ-NOTE: copy-paste other checkers from Dealer SPA, when needed

export const isWholesaleType = (type?: WorkflowTypeId | null): boolean => {
  return type === WorkflowTypeId.Wholesale
}
